module.exports = __webpack_public_path__ + "icon-cart.png?d52a12b979e73a7e0b31a62ab4df7a20";